export const logicOperators = {
  and: 'and',
  or: 'or',
}
